module.exports = __webpack_public_path__ + "img/Weapon_287.766cd7df.png";